import { createContext } from 'react';

export type ToastType = 'success' | 'error' | 'warning' | 'info';
export type ToastPosition =
  | 'top-left'
  | 'top-right'
  | 'top-center'
  | 'bottom-left'
  | 'bottom-right'
  | 'bottom-center';

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
  createdAt: number;
  position: ToastPosition;
  duration: number;
}

export interface ToastContextProps {
  toasts: Toast[];
  notify: (
    type: ToastType,
    message: string,
    position?: ToastPosition,
    duration?: number
  ) => void;
  removeToast: (id: string) => void;
  position: ToastPosition;
  setPosition: (position: ToastPosition) => void;
}

export const ToastContext = createContext<ToastContextProps | undefined>(
  undefined
);
